import { getScheduleHourSummary } from "./DailyNoLaborModelMetricsCard";

// A weekly Actual comparison covers completed store business dates only.
// Keep data provenance separate from totals: regrouping floating-point hours
// must never be interpreted as missing intraday data.
export function getWeeklyActualMetrics({ days, businessDate, earned = [], actual = [], cards = [] }) {
  const completed = days.filter(day => day.date < businessDate);
  const dates = new Set(completed.map(day => day.date));
  const earnedRows = earned.filter(row => dates.has(row.date));
  const actualRows = actual.filter(row => dates.has(row.date));
  const sum = rows => rows.reduce((total, row) => total + row.hours, 0);
  const coverage = completed.map(day => {
    const targets = earnedRows.filter(row => row.date === day.date);
    const derived = actualRows.filter(row => row.date === day.date);
    const punches = cards.filter(card => card.date === day.date);
    const punchHours = getScheduleHourSummary([], punches).actual;
    const closedWithoutWork = day.closed && !day.hasScheduledHours &&
      !derived.some(row => Number(row.hours) > 0) &&
      !punches.some(card => Number(card.hours) > 0);
    return {
      targetAvailable: targets.length > 0 || closedWithoutWork,
      actualAvailable: derived.length > 0 || punchHours !== null || closedWithoutWork,
      gradeAvailable: derived.length > 0 || closedWithoutWork,
      hours: derived.length ? sum(derived) : (punchHours ?? (closedWithoutWork ? 0 : null)),
    };
  });
  return {
    dates,
    earnedRows,
    actualRows,
    hasTarget: earnedRows.length > 0 && coverage.every(day => day.targetAvailable),
    actualComplete: completed.length > 0 && coverage.every(day => day.actualAvailable),
    gradeAvailable: actualRows.length > 0 && coverage.every(day => day.gradeAvailable),
    actualHours: coverage.some(day => day.hours !== null)
      ? coverage.reduce((total, day) => total + (day.hours ?? 0), 0)
      : null,
  };
}
